export interface IApiState {
    apiCallsInProgress: number;
    notifications:Array<any>;
  }

export const initialApiState: IApiState = {
    apiCallsInProgress: 0,
    notifications: []
}
